<app-carousel [typeSearch]="'Employee'"></app-carousel>
<div class="body-app mt-3 mb-3">
  <div class="content-app">
    <h5 class="mt-0 mb-2">
      <i class="fa-solid fa-circle-user"></i>
      Crear mi cuenta
    </h5>
    <!-- <p class="text-justify mb-3">
      Lorem ipsum dolor, sit amet consectetur adipisicing elit. Harum dolorum expedita quod ullam facere illo asperiores earum
      reprehenderit, aperiam, accusantium, ipsa iure inventore saepe deleniti sunt impedit aliquam aspernatur maxime?
    </p> -->
    <h5 class="mt-0 mb-2">
      Quiero crear mi cuenta y soy una
    </h5>
    <div class="row mb-2">
      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
        <button (click)="setTypePerson(rolesId.Company)" type="button" class="btn btn-primary-theme w-100 d-flex flex-column justify-content-center align-items-center" [ngClass]="typePerson == rolesId.Company ? 'active':''">
          <i class="fa-regular fa-building fa-5x mt-3 mb-2"></i>
          <span class="fs-5 mb-3">Empresa</span>
        </button>
      </div>
      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
        <button (click)="setTypePerson(rolesId.Member)" type="button" class="btn btn-primary-theme w-100 d-flex flex-column justify-content-center align-items-center" [ngClass]="typePerson == rolesId.Member ? 'active':''">
          <i class="fa-solid fa-user-tie fa-5x mt-3 mb-2"></i>
          <span class="fs-5 mb-3">Persona</span>
        </button>
      </div>
    </div>
    <hr class="mt-3 mb-3" />
    <div *ngIf="typePerson == rolesId.Company">
      <app-register-form-company  [showSaveButton]="false" [showSaveRegister]="true"></app-register-form-company>
    </div>
    <div *ngIf="typePerson == rolesId.Member">
      <app-register-form-natural-person  [typePerson]="typePerson" [showSaveButton]="false" [showSaveRegister]="true"></app-register-form-natural-person>
    </div>
  </div>
</div>
